var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefereeOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.875 23.7502C0.875 19.923 9.6199 17.5835 14 17.5835C18.3808 17.5835 27.125 19.923 27.125 23.7502V28.3752H0.875V23.7502Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875 23.7502C0.875 19.923 9.6199 17.5835 14 17.5835C18.3808 17.5835 27.125 19.923 27.125 23.7502V28.3752H0.875V23.7502Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875 23.7502C0.875 19.923 9.6199 17.5835 14 17.5835C18.3808 17.5835 27.125 19.923 27.125 23.7502V28.3752H0.875V23.7502Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875 23.7502C0.875 19.923 9.6199 17.5835 14 17.5835C18.3808 17.5835 27.125 19.923 27.125 23.7502V28.3752H0.875V23.7502Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875 23.7502C0.875 19.923 9.6199 17.5835 14 17.5835C18.3808 17.5835 27.125 19.923 27.125 23.7502V28.3752H0.875V23.7502Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875 23.7502C0.875 19.923 9.6199 17.5835 14 17.5835C18.3808 17.5835 27.125 19.923 27.125 23.7502V28.3752H0.875V23.7502Z",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 16.0417C18.0271 16.0417 21.2916 12.5906 21.2916 8.33333C21.2916 4.07602 18.0271 0.625 13.9999 0.625C9.97273 0.625 6.70825 4.07602 6.70825 8.33333C6.70825 12.5906 9.97273 16.0417 13.9999 16.0417Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefereeOthers);
export default __webpack_public_path__ + "static/media/referee_others.3eeab13b9e2470cb9bbe6800b1607d72.svg";
export { ForwardRef as ReactComponent };